import React from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import './index.css';

const mapStyles = {
  width: '100%',
  height: '100%',
};

const containerStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%'
}
class GoogleMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { markerList } = this.props;
    console.log(markerList);
  }
  render() {
    const { markerList } = this.props;
    return (
      <Map
        google={this.props.google}
        style={mapStyles}
        containerStyle={containerStyle}
        initialCenter={this.props.initialCenter || { lat: 47.444, lng: -122.176}}
        {...this.props}
      >
        {markerList && markerList.map((marker, index) => (
          <Marker
            title={marker.title}
            name={marker.name}
            position={{ lat: marker.latitude, lng: marker.longitude }}
            key={index}
          />
        ))}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCIl7n9qiUeCUK0MkQim1h0LOATsRCiBhc'
})(GoogleMap);